import { MdInfoOutline } from 'react-icons/md';

import styles from './styles.module.scss';

const NoticeMessage = ({ children }: { children: React.ReactNode }) => (
  <div className={`${styles.notice} ${styles.container}`}>
    <div className={styles.icon}>
      <MdInfoOutline size="24px" />
    </div>
    <div className={styles.message}>
      <div>{children}</div>
    </div>
  </div>
);

export default NoticeMessage;
